// "Dati Tenax" sections of people and organizations (task 1.5, D-033).
export const tenaxPeopleEnglishMessages = {
  tenax: {
    people: {
      section: "Tenax data",
      fields: {
        org_type: "Type",
        region: "Region",
        country_code: "Country (ISO code)",
        language: "Language",
        priority: "Priority",
        group_name: "Group",
        courts_count: "Courts",
        introduced_by_contact_id: "Brought in by",
        min_order_amount: "Minimum order (€)",
        payment_method: "Payment",
        payment_discount_pct: "Payment discount (%)",
        consignment: "On consignment",
        unsold_exchange_used_at: "Unsold exchange used on",
        unsold_exchange_hint: "A reminder, not a limit",
        recontact_month: "Month to get back in touch",
        fic_client_id: "Client in Fatture in Cloud",
        origin: "Origin",
        channel: "Channel",
        roles: "Roles",
        teaches_at: "Clubs where they teach",
        instagram_handle: "Instagram (without @)",
        instagram_followers: "Instagram followers",
        fitp_qualification: "FITP qualification",
        player_level: "Level",
        home_club_id: "Home club",
        coach_contact_id: "Coach",
        marketing_consent: "Marketing consent",
        consent_source: "Consent source",
        consent_at: "Consent given on %{date}",
      },
      org_type: {
        club: "Club",
        shop: "Shop",
        foreign_retailer: "Foreign retailer",
        foreign_partner: "Foreign partner",
        business_partner: "Business partner",
        marketplace: "Marketplace",
        supplier: "Supplier",
        other: "Other",
        corporate_client: "Corporate client",
      },
      role: {
        coach: "Coach",
        player: "Player",
        athlete: "Athlete",
        referent: "Referent",
        agent: "Agent",
        supplier: "Supplier",
        press: "Press",
        other: "Other",
      },
      origin: {
        instagram: "Instagram",
        fitp: "FITP",
        tournament: "Tournament",
        website: "Website",
        amazon: "Amazon",
        word_of_mouth: "Word of mouth",
        fair: "Fair",
        import_excel: "Excel import",
        coach_database: "Coach database",
        other: "Other",
      },
      channel: {
        whatsapp: "WhatsApp",
        instagram_dm: "Instagram message",
        phone: "Phone",
        email: "Email",
        meeting: "Meeting",
        other: "Other",
      },
      payment_method: {
        riba: "Ri.Ba.",
        bank_transfer: "Bank transfer",
        card: "Card",
        other: "Other",
      },
      priority: {
        1: "High",
        2: "Normal",
        3: "Low",
      },
      duplicates: {
        title: "Possible duplicate",
        hint: "You can save anyway: this is only a warning.",
        matched_on: {
          email: "same email",
          phone: "same phone",
          name: "same name",
        },
      },
    },
  },
};

export const tenaxPeopleItalianMessages = {
  tenax: {
    people: {
      section: "Dati Tenax",
      fields: {
        org_type: "Tipo",
        region: "Regione",
        country_code: "Paese (codice ISO)",
        language: "Lingua",
        priority: "Priorità",
        group_name: "Gruppo",
        courts_count: "Campi",
        introduced_by_contact_id: "Portato da",
        min_order_amount: "Ordine minimo (€)",
        payment_method: "Pagamento",
        payment_discount_pct: "Sconto legato al pagamento (%)",
        consignment: "Conto vendita",
        unsold_exchange_used_at: "Cambio invenduto usato il",
        unsold_exchange_hint: "Un promemoria, non un limite",
        recontact_month: "Mese di ricontatto",
        fic_client_id: "Cliente in Fatture in Cloud",
        origin: "Origine",
        channel: "Canale",
        roles: "Ruoli",
        teaches_at: "Circoli dove insegna",
        instagram_handle: "Instagram (senza @)",
        instagram_followers: "Follower Instagram",
        fitp_qualification: "Qualifica FITP",
        player_level: "Livello",
        home_club_id: "Circolo abituale",
        coach_contact_id: "Maestro di riferimento",
        marketing_consent: "Consenso marketing",
        consent_source: "Fonte del consenso",
        consent_at: "Consenso dato il %{date}",
      },
      org_type: {
        club: "Circolo",
        shop: "Negozio",
        foreign_retailer: "Retailer estero",
        foreign_partner: "Partner estero",
        business_partner: "Partner commerciale",
        marketplace: "Marketplace",
        supplier: "Fornitore",
        other: "Altro",
        corporate_client: "Azienda cliente",
      },
      role: {
        coach: "Maestro",
        player: "Giocatore",
        athlete: "Atleta",
        referent: "Referente",
        agent: "Agente",
        supplier: "Fornitore",
        press: "Stampa",
        other: "Altro",
      },
      origin: {
        instagram: "Instagram",
        fitp: "FITP",
        tournament: "Torneo",
        website: "Sito",
        amazon: "Amazon",
        word_of_mouth: "Passaparola",
        fair: "Fiera",
        import_excel: "Import da Excel",
        coach_database: "Database maestri",
        other: "Altro",
      },
      channel: {
        whatsapp: "WhatsApp",
        instagram_dm: "Messaggio Instagram",
        phone: "Telefono",
        email: "Email",
        meeting: "Incontro",
        other: "Altro",
      },
      payment_method: {
        riba: "Ri.Ba.",
        bank_transfer: "Bonifico",
        card: "Carta",
        other: "Altro",
      },
      priority: {
        1: "Alta",
        2: "Normale",
        3: "Bassa",
      },
      duplicates: {
        title: "Possibile doppione",
        hint: "Puoi salvare lo stesso: è solo un avviso.",
        matched_on: {
          email: "stessa email",
          phone: "stesso telefono",
          name: "stesso nome",
        },
      },
    },
  },
};
